import React from 'react';
import { IIconProps } from './utils';

export const ThumbDown = ({
  fill = 'currentColor',
  height,
  size = 20,
  width,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height || size}
    viewBox="0 0 15 14"
    width={width || size}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.9258 6.46598L13.7368 2.48242C13.297 1.00911 11.9478 0.000163078 10.4174 0.000163078L4.58333 0.000258446C4.35321 0.000261307 4.16667 0.186809 4.16667 0.416924V8.32331C4.16667 8.54225 4.33874 8.71873 4.54824 8.78231C4.81933 8.86458 5.06879 9.01315 5.27268 9.21807L6.25238 10.2027C6.69652 10.6491 7.0116 11.2085 7.16394 11.8209L7.26764 12.2378C7.3309 12.4921 7.46176 12.7244 7.64621 12.9098C8.20827 13.4747 9.11954 13.4747 9.6816 12.9098L9.77027 12.8207C10.1589 12.4301 10.3151 11.8632 10.1818 11.3273L9.65895 9.22522C9.59357 8.96237 9.79243 8.70798 10.0633 8.70798H13.2661C14.4268 8.70798 15.2593 7.58339 14.9258 6.46598Z"
      fill={fill}
    />
    <path
      d="M0 7.83727V0.871013C0 0.390094 0.387895 0.000230789 0.866388 0.000230789H2.08333C2.31345 0.000230789 2.5 0.186779 2.5 0.416897V8.29138C2.5 8.5215 2.31345 8.70805 2.08333 8.70805H0.866388C0.387895 8.70805 0 8.31819 0 7.83727Z"
      fill={fill}
    />
  </svg>
);
